module.exports = __webpack_public_path__ + "static/media/appstore-6e.87eb4fe9.png";